import { useState,useEffect} from 'react'
import { useCurrent, useFetch, usePut } from '../../../hooks';
import { MwButton, MwSpinner} from '../../ui';
import {langObjType,objLangTextHandler,LangArrayToObjKeyValue} from '../../../utils/global'
import CategoryForm from './CategoryForm';
import CardHeadeWithActions from '../../ui/CardHeadeWithActions';
import { useTranslation } from 'react-i18next';
import { normalizeApiCollection, normalizeApiItem } from '../productUi';

const EditCategory = ({id,setMode}) => {
    const [t] = useTranslation('global')

    const {currentLangList,currentTenantId,currentCompanyId,currentLangId} = useCurrent();
    const [formLang,setFormLang] = useState(currentLangId);
    const [errors,setErrors] = useState({});
    const [categories,setCategories] = useState([]);
    const categoryClasses = [
        {label: t('product.product'), value: 'product'},
        {label: t('product.service'), value: 'service'},
    ];
    
    const {data:dataFetchCategory} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/categories/show/${id}`);
    const {data:resultPut,putData} = usePut();
    const {data:dataFetchResponse} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/categories/${currentTenantId}/${currentCompanyId}`);
    
    const [loadingPage,setLoadingPage] = useState(true);
    const [categoryClassLabel,setCategoryClassLabel] = useState(t('product.select_category_class'));

    const [categoryParent,setCategoryParent] = useState('main');
    const [categoryClass,setCategoryClass] = useState();
    const [isActive,setIsActive] = useState(true);
    const [isShowOnWebsite,setIsShowOnWebsite] = useState(true);
    const [categoryName,setCategoryName] = useState(langObjType());
    const [categoryDesc,setCategoryDesc] = useState(langObjType());
    const [categoryMetaKeywords,setCategoryMetaKeywords] = useState(langObjType());
    const [categoryMetaDesc,setCategoryMetaDesc] = useState(langObjType());
    const [categoryCode,setCategoryCode] = useState('');

    const formValidate = () => {
        let errorObj = {};
        setErrors({});
        if(categoryParent==='sub'){
            errorObj = { ...errorObj, categoryParent : t('validation.selectSubCategory')  };
        }
        if(!categoryClass){
            errorObj = { ...errorObj, categoryClass : t('validation.selectCategoryClass') };
        }
        if(!categoryName[currentLangId]){
            errorObj = { ...errorObj, [`categoryName.${currentLangId}`] : t('validation.enterCategoryName')};
            setFormLang(currentLangId)
        }

        if(Object.keys(errorObj).length !== 0 ){
            setErrors(errorObj)
            return true
        }

        return false;
    }

    const submitHandler = () => {        
        const parentPrefix = categoryParent?.data?.categoryCode;
        const normalizedCategoryCode = categoryParent === 'main'
            ? categoryCode
            : (parentPrefix && !categoryCode?.includes(parentPrefix))
                ? `${parentPrefix}-${categoryCode}`
                : categoryCode;

        const _data = {
            categoryParent:categoryParent === 'main' ? null : categoryParent.value,
            categoryClass,
            categoryCode: normalizedCategoryCode,
            categoryName: objLangTextHandler(categoryName),
            categoryDesc: objLangTextHandler(categoryDesc),
            categoryMetaKeywords: objLangTextHandler(categoryMetaKeywords),
            categoryMetaDesc: objLangTextHandler(categoryMetaDesc),
            isActive,
            isShowOnWebsite,
            tenantId:currentTenantId,
            companyId:currentCompanyId
        }
        
        if(formValidate()) return;
        putData(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/categories/update/${id}`,_data);
    }

    useEffect(() =>{
        if(dataFetchResponse){
            const cats = [];
            normalizeApiCollection(dataFetchResponse).forEach((item) => {
                if(item._id !== id) {
                    item.categoryName.forEach((name) => {
                        cats.push({label:name?.text,value:item._id,lang:name.lang,data:item})
                    });
                }
            });
            setCategories(cats);
        }
    },[dataFetchResponse,id]);

    useEffect(() =>{
        if(resultPut?.status === 1){
            setMode('List');
        }
    },[resultPut,setMode])

    useEffect(() =>{
        const categoryItem = normalizeApiItem(dataFetchCategory);
        if(categoryItem){
            if(categoryItem.categoryParent === null) {
                setCategoryParent('main');
            } else if (categoryItem?.categoryParent?._id) {
                setCategoryParent({
                    label:LangArrayToObjKeyValue(categoryItem.categoryParent?.categoryName)?.[currentLangId],
                    value:categoryItem.categoryParent._id,
                    lang:currentLangId,
                    data:categoryItem.categoryParent,
                });
            }

            const labelClass = () => {
                if(categoryItem.categoryClass === 'product' ){
                    return t('product.product')
                }
                if(categoryItem.categoryClass === 'service' ){
                    return t('product.service')
                }
                return t('product.Other')
            } 

            setCategoryClassLabel(labelClass());
            setCategoryClass(categoryItem.categoryClass);
            setCategoryName(LangArrayToObjKeyValue(categoryItem.categoryName))
            setCategoryDesc(LangArrayToObjKeyValue(categoryItem.categoryDesc))
            setCategoryMetaKeywords(LangArrayToObjKeyValue(categoryItem.categoryMetaKeywords))
            setCategoryMetaDesc(LangArrayToObjKeyValue(categoryItem.categoryMetaDesc))
            setIsShowOnWebsite(categoryItem.isShowOnWebsite)
            setIsActive(categoryItem.isActive)
            setCategoryCode(categoryItem?.categoryCode || '')
            setLoadingPage(false)
        }
    },[currentLangId,dataFetchCategory,t]);

    return (
        <div className='p-3'>
            {dataFetchCategory && !loadingPage ? (
                <div className='flex flex-col gap-5 px-3 text-sm text-slate-500'>
                    <CardHeadeWithActions title={t('validation.UpdateCategory')}>
                        <MwButton type="saveBtn" inGroup={true} onClick = {()=>setMode('List')} > {t('product.manageCategories')}  </MwButton>
                        <MwButton type="saveBtn" inGroup={true} onClick={submitHandler} >{t('product.save')}</MwButton>
                    </CardHeadeWithActions>
                    <CategoryForm
                        categories={categories}
                        currentLangList={currentLangList}
                        formLang={formLang}
                        setFormLang={setFormLang}
                        errors={errors}
                        categoryParent={categoryParent}
                        setCategoryParent={setCategoryParent}
                        categoryClasses={categoryClasses}
                        categoryClass={categoryClass}
                        setCategoryClass={setCategoryClass}
                        categoryClassLabel={categoryClassLabel}
                        categoryName={categoryName}
                        setCategoryName={setCategoryName}
                        categoryDesc={categoryDesc}
                        setCategoryDesc={setCategoryDesc}
                        categoryMetaKeywords={categoryMetaKeywords}
                        setCategoryMetaKeywords={setCategoryMetaKeywords}
                        categoryMetaDesc={categoryMetaDesc}
                        setCategoryMetaDesc={setCategoryMetaDesc}
                        isShowOnWebsite={isShowOnWebsite}
                        setIsShowOnWebsite={setIsShowOnWebsite}
                        isActive={isActive}
                        setIsActive={setIsActive}
                        categoryCode={categoryCode}
                        setCategoryCode={setCategoryCode}
                    />
                </div>
            ) : <MwSpinner/>}
        </div>
    )
}

export default EditCategory
